import _ from 'lodash';
import { getAxiosClient } from '~src/api';

export const getTemplateCategoryName = (template) =>
  template?.metadata?.templatesCategoryName ||
  template?.editor_templates_categories_default_pointer?.name ||
  template?.editor_templates_categories_pointer?.name ||
  '';

export const getTemplateCategoryPayload = (category, fallbackCategoryId) => ({
  categoryId: category?.objectId || fallbackCategoryId || null,
  categoryName: category?.name || null,
  categoryIsDefault: category?.isGlobal === true,
});

const fetchCategories = async (httpClient, tableName, params, isGlobal) => {
  const response = await httpClient.get(
    `${process.env.PARSE_API_URL}/${tableName}`,
    {
      params: {
        sort_ascending: 'order',
        ...params,
      },
    }
  );

  return (response.data?.data || []).map((category) => ({
    ...category,
    isGlobal,
  }));
};

export const fetchTemplateCategoriesForProjectType = async (projectType) => {
  if (!projectType?.objectId) return [];

  const httpClient = await getAxiosClient();
  const requests = [];

  if (projectType.isGlobal === true) {
    const params = {
      filterEqual_editor_project_types_default_pointer: projectType.objectId,
    };

    requests.push(
      fetchCategories(
        httpClient,
        'editor_templates_categories_default',
        params,
        true
      )
    );
    requests.push(
      fetchCategories(httpClient, 'editor_templates_categories', params, false)
    );
  } else {
    requests.push(
      fetchCategories(
        httpClient,
        'editor_templates_categories',
        {
          filterEqual_editor_project_types_pointer: projectType.objectId,
        },
        false
      )
    );
  }

  const categories = (await Promise.all(requests)).flat();
  return _.orderBy(_.uniqBy(categories, 'objectId'), ['order', 'name']);
};
